module.exports = [
    {
        "label": "A guest has an upcoming booking",
        "value": "guest_upcoming_booking"
    },
    {
        "label": "Guest checked-in",
        "value": "guest_checked_in"
    },
    {
        "label": "Guest checked-out",
        "value": "guest_checked_out"
    },
    {
        "label": "Guests'country",
        "value": "guest_country"
    },
    {
        "label": "Length of stay",
        "value": "guest_length_stay"
    },
    {
        "label": "Members Birthday",
        "value": "member_birthday"
    },
    {
        "label": "Member Joining Date",
        "value": "member_joining_date"
    }
]